export const REPORTS_LIST_TABLE = 'reportsListTable';
export const USE_TEMPLATE_FOR_REPORT = 'useTemplateForReport';
